import {
    Box,
    FormControlLabel,
    FormGroup,
    Popover,
    Radio,
    RadioGroup,
    Typography,
  } from "@mui/material";
  import React from "react";
  import { RxCross2 } from "react-icons/rx";
  
  interface PopOverProps {
    handleFilterChange?: ((value: string) => void);
    handleSortByChange?: (value: string) => void;
    handleSortOrder?: (value: string) => void;
    filterValue?: string;
    handleClose: () => void;
    openOptions: boolean;
    anchorE: null | HTMLElement;
    sortOrderLabels?: { label: string; value: string }[];
    sortOptions?: { label: string; value: string }[];
    style?: React.CSSProperties;
    clearFilter?: (value: string) => void;
    clearSort?: (value: string) => void;
    customStatusList?: {
      active: boolean;
      agentLabel: string;
      endUserLabel: string;
      id: number;
      statusCategory: string;
    }[];
    sortByOrder?: string;
    sortByValue?: string;
  }
  
  const PopOver: React.FC<PopOverProps> = ({
    handleFilterChange,
    handleSortByChange,
    handleSortOrder,
    clearFilter,
    clearSort,
    filterValue,
    handleClose,
    openOptions,
    anchorE,
    customStatusList,
    sortOrderLabels,
    sortOptions,
    style,
    sortByOrder,
    sortByValue,
  }) => {
    return (
      <Box
        sx={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          backgroundColor: "rgba(0, 0, 0, 0.2)",
          zIndex: 1300,
        }}
      >
        <Popover
          id="1"
          open={openOptions}
          anchorEl={anchorE}
          onClose={handleClose}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "left",
          }}
          sx={{
            "@media(max-width:634px)": {
              "& .MuiPopover-paper": {
                width: "87%",
                ...style,
              },
            },
            "@media(max-width:425px)": {
              "& .MuiPopover-paper": {
                width: "85%",
              },
            },
            "@media(max-width:375px)": {
              "& .MuiPopover-paper": {
                width: "83%",
              },
            },
          }}
        >
          <FormGroup className="!relative !left-0">
            <RadioGroup
              aria-labelledby="demo-radio-buttons-group-label"
              defaultValue={filterValue}
              name="radio-buttons-group"
            >
              {customStatusList && (
                <>
                  {customStatusList.map(
                    (item) =>
                      (item.active === true &&
                      item.agentLabel !== "Closed" && item.agentLabel !== "Open" && item.agentLabel !== "Pending") && (
                        <FormControlLabel
                          key={item.agentLabel}
                          className="pl-4 pr-8 !mr-0 border-b-2 hover:bg-zinc-100"
                          value={item.id}
                          onChange={() =>
                            handleFilterChange?.(item.id.toString())
                          }
                          control={<Radio sx={{'&.Mui-checked': {
                            color: '#318FE0'}}}/>}
                          label={
                            <Typography sx={{fontSize:"14px"}}>{item.agentLabel} Tickets</Typography>
                          }
                        />
                      )
                  )}
                  <Box className="flex items-center cursor-pointer hover:bg-zinc-100">
                    <Typography className="pl-4 pr-3">
                      <RxCross2 size={20} />
                    </Typography>
                    <Typography
                      className="py-2"
                      sx={{fontSize:"14px"}}
                      onClick={() => clearFilter?.("")}
                    >
                      Clear All
                    </Typography>
                  </Box>
                </>
              )}
            </RadioGroup>
  
            {sortOrderLabels && sortOptions && (
              <>
                <RadioGroup
                  row
                  aria-labelledby="demo-radio-buttons-group-label"
                  defaultValue={sortByValue}
                  name="radio-buttons-group"
                  sx={{fontSize:"14px"}}
                >
                  {sortOptions.map((item) => (
                    <FormControlLabel
                    sx={{fontSize:"14px"}}
                      className="pl-4  "
                      value={item.value}
                      onChange={() => handleSortByChange?.(item.value)}
                      control={<Radio sx={{fontSize:"14px", '&.Mui-checked': {
                             color: '#318FE0'}}}/>}
                      label={item.label}
                      key={item.label}
                    />
                  ))}
                </RadioGroup>
  
                {sortOrderLabels.map((item) => (
                  <Typography
                    key={item.label}
                    sx={{fontSize:"14px"}}
                    className={`pl-4 py-2 pr-14  border-b-2  cursor-pointer ${
                      item.value === sortByOrder && "bg-[#318FE0] text-[#fff]"
                    }`}
                    onClick={() => handleSortOrder?.(item.value)}
                  >
                    {item.label}
                  </Typography>
                ))}
  
                <Box className="flex items-center cursor-pointer hover:bg-zinc-100">
                  <Typography className="pl-4 pr-3">
                    <RxCross2 size={14}  />
                  </Typography>
                  <Typography className="py-2" sx={{fontSize:"14px"}} onClick={() => clearSort?.("")}>
                    Clear All
                  </Typography>
                </Box>
              </>
            )}
          </FormGroup>
        </Popover>
      </Box>
    );
  };
  
  export default PopOver;
  